import { Button } from '@mui/material';
import { getTrans } from 'modules/i18n';
import { useStepValidation } from '../hooks';
import { StepKey } from '../stepMeta';
import { ButtonContainer } from './styledComponents';

interface PreviousStepNavigationButtonProps {
  step: StepKey;
  children?: React.ReactNode;
}

export const PreviousStepNavigationButton: React.FC<
  PreviousStepNavigationButtonProps
> = ({ step, children = getTrans('general.previous') }) => {
  const { hasPreviousStep, handlePreviousStepNavigation } =
    useStepValidation(step);

  // The wizard deliberately has no route back into the intro/overview, so on the first
  // data step this button had nothing to do — it rendered fully enabled and did nothing
  // when tapped. Render nothing instead of an inert control.
  if (!hasPreviousStep) {
    return null;
  }

  return (
    <ButtonContainer sx={{ pt: 3 }}>
      <Button
        data-testid="previous-step-navigation-button"
        color="secondary"
        variant="outlined"
        onClick={handlePreviousStepNavigation}
        sx={{ minWidth: 252 }}
        fullWidth
      >
        {children}
      </Button>
    </ButtonContainer>
  );
};
